import logreg from '../js/logreg';
export default {
  name: 'phoneinput',
  props: {
    mb: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      phone: '',
      errorTxt: ''
    };
  },
  components: {},
  methods: {
    phoneInput: function phoneInput() {
      if (!this.phone) {
        this.errorTxt = this.$t(this.$loginLangPrefix('userSign.webLoginPhoneTips'));
      } else if (logreg.validate(this.phone, 'phone')) {
        this.errorTxt = '';
      } else {
        this.errorTxt = this.$t(this.$loginLangPrefix('userSign.webLoginPhoneTips'));
      }
      this.$emit('changeErrorTxt', this.errorTxt);
      this.$emit('changePhone', this.phone);
    },
    deleteInput: function deleteInput() {
      this.phone = '';
      this.phoneInput();
    },
    next: function next() {
      this.$emit('btnSure');
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};